import React from "react";

// Official DREZORO logo — geometric D monogram + wordmark (inline SVG: razor sharp at any size).
export const DrezoroMark = ({ size = 32 }) => (
  <svg width={size} height={size} viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="DREZORO mark">
    <rect x="1" y="1" width="62" height="62" rx="14" fill="#111113" stroke="#2E2E33" strokeWidth="2" />
    <path d="M23 18 H34 A14 14 0 0 1 34 46 H23 V18 Z" stroke="#E4E4E7" strokeWidth="4" strokeLinejoin="round" fill="none" />
    <circle cx="49" cy="32" r="3.2" fill="#3B82F6" />
  </svg>
);

export const DrezoroLogo = ({ height = 28, tagline = false }) => (
  <span className="inline-flex items-center gap-3" style={{ height }}>
    <DrezoroMark size={height} />
    <span className="flex flex-col justify-center">
      <span className="font-head font-semibold text-white leading-none"
        style={{ fontSize: Math.round(height * 0.62), letterSpacing: "0.28em" }}>
        DREZOR<span className="text-blue-500">O</span>
      </span>
      {tagline && (
        <span className="text-zinc-500 font-medium" style={{ fontSize: Math.max(7, Math.round(height * 0.24)), letterSpacing: "0.3em", marginTop: 3 }}>
          TECHNOLOGY GROUP
        </span>
      )}
    </span>
  </span>
);
